import { render } from "./CreditHistoryCard.vue?vue&type=template&id=01bc955b&scoped=true"
import script from "./CreditHistoryCard.vue?vue&type=script&lang=js"
export * from "./CreditHistoryCard.vue?vue&type=script&lang=js"

import "./CreditHistoryCard.vue?vue&type=style&index=0&id=01bc955b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc955b"]])

export default __exports__